module.exports = __webpack_public_path__ + "img/2018-2020.c467cf69.png";